<template>
  <div id="navLayout">
    <header-container></header-container>
    <router-view class="router-view"></router-view>
    <footer-container></footer-container>
  </div>
</template>

<script>
  import headerContainer from '../common/header.vue';
  import footerContainer from '../common/footer.vue';
  export default {
    name: 'navLayout',
    data() {
      return {
      }
    },
    components:{
      'footerContainer':footerContainer,
      'headerContainer':headerContainer,
    },
  }
</script>
<style lang="scss"  type="text/scss">
.router-view{
  // margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/navLayout.vue